import React from "react";
import { useSelector } from "react-redux";
import { Tooltip, formatCurrency } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getCurrencyCodeByProjectId, getFormatCurrencyArgs } from "~/store/selectors/selector.currencies.jsx";
import ExpenseTotalRealtimeEvents from "../Expenses/ExpenseTotalRealtimeEvents";

const TrackedExpense = ({ projectId, total, onOpenListModal, parentId }) => {
  const currencyCode = useSelector((state) => getCurrencyCodeByProjectId(state, projectId));

  const formatterArgs = useSelector((state) => getFormatCurrencyArgs(state, currencyCode));

  return (
    <>
      <ExpenseTotalRealtimeEvents
        parentId={parentId}
        parentType="Task"
      />
      <Tooltip
        title={formatCurrency(
          total,
          formatterArgs.thousand_separator,
          formatterArgs.decimal_separator,
          false,
          formatterArgs.decimal_spaces,
          "long",
          formatterArgs.code
        )}
        disable={total === 0}
      >
        <button
          className={classNames("c-pill-box__sum", {
            tracked_disabled_link: total === 0,
          })}
          onClick={onOpenListModal}
          disabled={total === 0}
        >
          <span className="tw-text-right tw-truncate tw-inline-block tw-align-top">
            {formatCurrency(
              total,
              formatterArgs.thousand_separator,
              formatterArgs.decimal_separator,
              true,
              formatterArgs.decimal_spaces,
              "short"
            )}
          </span>
          <sub className="tw-uppercase">{currencyCode}</sub>
        </button>
      </Tooltip>
    </>
  );
};

TrackedExpense.propTypes = {
  projectId: PropTypes.number.isRequired,
  parentId: PropTypes.number.isRequired,
  total: PropTypes.number,
  onOpenListModal: PropTypes.func,
};

TrackedExpense.defaultProps = {
  total: 0,
};

export default TrackedExpense;
